import * as React from 'react';

import { FORMALITIES_INVOICES_LIST } from './constants/paths';

import { InvoicesFormalitiesListBack } from './views/list';

export const FacturesRouterBack = {
    path: FORMALITIES_INVOICES_LIST,
    element: <InvoicesFormalitiesListBack />,
};
